<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
      <div class="row">
        <div
          class="col-md-4 col-lg-4 mb-4 special-card"
          *ngFor="let service of services"
        >
          <div class="card h-100 d-flex flex-column position-relative">
            <div class="image-wrapper">
              <div
                class="position-absolute top-0 end-0 m-2 z-1 dropdown button-badge"
              >
                <div ngbDropdown container="body">
                  <a
                    ngbDropdownToggle
                    href="javascript:void(0);"
                    class="hide-arrow btn btn-icon btn-light dropdown-toggle"
                    id="dropdownServiceActions"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i data-feather="more-vertical" class="text-primary"></i>
                  </a>
                  <div
                    ngbDropdownMenu
                    class="dropdown-menu dropdown-menu-right"
                    aria-labelledby="dropdownServiceActions"
                  >
                    <a
                      class="dropdown-item d-flex align-items-center text-primary"
                      [routerLink]="['/go-service/service-details', service.id]"
                    >
                      <i class="bi bi-info-circle mr-2"></i> Info
                    </a>

                                        <a
                      class="dropdown-item d-flex align-items-center "
                      [routerLink]="['/go-service/service-subscribers' , service.id]"
                    >
                      <i class="bi bi-person-fill-down mr-2"></i>Service Subscribers
                    </a>
                    <a
                      *ngIf="service.approvedByAdmin !== true"
                      class="dropdown-item d-flex align-items-center"
                      (click)="serviceStatus(service.id, true)"
                    >
                      <i class="bi bi-check text-success mr-2"></i> Accept
                    </a>
                    <a
                      *ngIf="service.approvedByAdmin !== false"
                      class="dropdown-item d-flex align-items-center"
                      (click)="programContentModal(rejection, service.id)"
                    >
                      <i class="bi bi-x text-danger mr-2"></i> Reject
                    </a>
                    <a
                      class="dropdown-item d-flex align-items-center"
                      (click)="serviceById(service.id)"
                    >
                      <i class="bi bi-trash text-danger mr-2"></i> Suspend
                      Service
                    </a>
                  </div>
                </div>
              </div>
              <img
                class="card-img-top img-fluid"
                [src]="service.banner?.url"
                alt="Card image cap"
                style="object-fit: cover; height: 200px"
              />
            </div>


            <div class="card-body d-flex flex-column flex-grow-1">
              <div class="d-flex justify-content-between align-items-center">
                <h4 class="card-title">{{ service.name }}</h4>
                <div class="d-flex flex-column align-items-end">
                  <span
                    *ngIf="service.approvedByAdmin === true"
                    class="custom-badge badge mb-1"
                    [ngClass]="{
                      'badge-light-secondary': service.status === 'draft',
                      'badge-light-primary': service.status === 'published',
                      'badge-light-danger': service.status === 'rejected'
                    }"
                  >
                    {{ service.status | uppercase }}</span
                  >

                  <span
                    class="custom-badge badge mb-1"
                    [ngClass]="{
                      'badge-light-danger': service.approvedByAdmin === false,
                      'badge-light-success': service.approvedByAdmin === true,
                      'badge-light-secondary': service.approvedByAdmin === null
                    }"
                  >
                    {{
                      (service.approvedByAdmin === true
                        ? "Approved"
                        : service.approvedByAdmin === false
                        ? "Rejected"
                        : "Waiting For Action"
                      ) | uppercase
                    }}

                    <ng-container *ngIf="service.approvedByAdmin === false">
                      <button
                        type="button"
                        class="btn btn-sm btn-icon btn-light-primary"
                        [ngbPopover]="milestoneContent"
                        popoverTitle="REJECTION REASON "
                        placement="left"
                        triggers=" click:blur"
                        container="body"
                      >
                        <i
                          data-feather="x-circle"
                          class="font-medium-1 text-danger"
                        ></i>
                      </button>

                      <ng-template #milestoneContent>
                        <div class="card-title">
                          <p class="text-black">
                            {{ service.rejectionReason }}
                          </p>
                        </div>
                      </ng-template>
                    </ng-container>
                  </span>
                </div>
              </div>

              <!-- Content section -->
              <p class="card-text">
                {{ service.description }}
              </p>

              <!-- First badge -->
              <div
                class="d-flex align-items-center justify-content-start truncated-lables"
              >
                <span class="badge bg-goalngo mr-1">
                  {{ service.category.split("_").join(" ") | uppercase }}
                </span>

                <span class="badge bg-goalngo">
                  {{ service.subCategory }}
                </span>
              </div>

              <!-- Footer section pinned to bottom -->
              <div
                class="mt-auto pt-3 d-flex justify-content-between align-items-center border-top"
              >
                <span class="d-flex align-items-center">
                  <i
                    class="bi bi-check-circle bg-outline-goalngo"
                    style="font-size: 1.5rem; margin-right: 0.5rem"
                  ></i>
                  {{ service.completedJobs }} Job Completed
                </span>
                <div class="d-flex flex-column align-items-center">
                  <span
                    class="badge bg-goalngo text-white fs-2 fw-bold rounded-pill"
                  >
                    {{
                      service.paymentConfig?.amount / 100 +
                        " " +
                        service.paymentConfig?.currency
                    }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    <div *ngIf="services?.length == 0" class="card d-flex justify-content-center align-items-center h-75">
      <div class="text-center py-5">
        <i class="bi bi-inbox text-muted" style="font-size: 3rem;"></i>
        <h3 class="font-weight-bold mt-2 text-danger">Oops! <span class="text-dark">No services found</span></h3>
      </div>
    </div>
  </div>